<template>
  <div class="header">
    <img class="logo" src="@/assets/m/logo.png">
    <span class="logo-text">大国工匠人才培育工程</span>
    <div class="message" :class="{'hasUnread': isMessageRead}" @click="$router.push('/messageList')"></div>
    <div class="user-info a-single-ellipsis" v-if="userInfo" @click="$router.push('/userCenter',()=>{},()=>{})">
      <img class="avatar" :src="userInfo.image || require('@/assets/pc/login/per_img.png')">
      {{ userInfo.name }}
    </div>
    <img class="menus" src="@/assets/m/menus-btn.png" @click="showMenu = !showMenu">
    <div class="menu-list-layer" v-if="showMenu">
      <ul class="menu-list">
        <li class="menu" :class="{'active': $route.name=='Index'}" @click="$router.push('/',()=>{},()=>{}), showMenu=false">首页</li>
        <li class="menu" :class="{'active': $route.name=='CourseList'}" @click="$router.push('/courseList',()=>{},()=>{}), showMenu=false">课程专区</li>
        <li class="menu" :class="{'active': $route.name=='Clearinghouse'}" @click="$router.push('/clearinghouse',()=>{},()=>{}), showMenu=false">交流中心</li>
        <li class="menu" :class="{'active': $route.name=='RankList'}" @click="$router.push('/rankList',()=>{},()=>{}), showMenu=false">学习积分</li>
        <!-- <li class="menu" :class="{'active': $route.name=='ActivityList'}" @click="$router.push('/activityList',()=>{},()=>{}), showMenu=false">活动简报</li> -->
        <li class="menu" :class="{'active': $route.name=='UserCenter'}" @click="$router.push('/userCenter',()=>{},()=>{}), showMenu=false">个人中心</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      showMenu: false
    };
  },
  computed: {
    ...mapState(['userInfo', 'isMessageRead'])
  }
};
</script>

<style scoped lang="scss">
.header{
  width: 100%;
  height: 48px;
  padding: 0 14px;
  background: #FFF;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
}
.user-info{
  max-width: 90px;
  font-size: 14px;
  color: #333333;
  margin: 0 20px 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar{
  width: 26px;
  height: 26px;
  border-radius: 50%;
  margin-right: 4px;
}
.login-btn{
  font-weight: 500;
  font-size: 16px;
  color: #2973F0;
  margin-left: auto;
  margin-right: 40px;
}
.logo{
  width: 20px;
  height: 20px;
  margin: 0 !important;
}
.logo-text{
  font-family: 'PingFangSC-Medium';
  font-weight: normal;
  font-size: 13px;
  color: #3C3C3C;
  margin-left: 3px;
  margin-right: auto;
  white-space: normal;
}
.menus{
  width: 20px;
}
.menu-list-layer{
  position: fixed;
  top: 48px;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(15, 15, 15, 0.7);
  z-index: 999;
}
.menu-list{
  width: 179px;
  padding: 15px 30px;
  background: #FFFFFF;
  border-bottom-left-radius: 10px;
  box-shadow: 0px 2px 4px 1px rgba(180,180,180,0.14);
  position: absolute;
  right: 0;
  top: 0;
  .menu{
    width: 100%;
    height: 52px;
    line-height: 52px;
    padding-left: 43px;
    border-bottom: 1px solid #F7F7F7;
    font-size: 16px;
    color: #999;
    &:nth-child(1){
      background: url('@/assets/m/menu-1.png') no-repeat 12px center/16px;
    }
    &:nth-child(2){
      background: url('@/assets/m/menu-2.png') no-repeat 12px center/16px;
    }
    &:nth-child(3){
      background: url('@/assets/m/menu-3.png') no-repeat 12px center/16px;
    }
    &:nth-child(4){
      background: url('@/assets/m/menu-9.png') no-repeat 12px center/16px;
    }
    &:nth-child(5){
      background: url('@/assets/m/menu-6.png') no-repeat 12px center/16px;
    }
    &:nth-child(6){
      background: url('@/assets/m/menu-8.png') no-repeat 12px center/16px;
    }
    &:nth-child(7){
      background: url('@/assets/m/menu-7.png') no-repeat 12px center/16px;
    }
    &.active{
      color: #2973F0;
      &:nth-child(1){
        background: url('@/assets/m/menu-11.png') no-repeat 12px center/16px;
      }
      &:nth-child(2){
        background: url('@/assets/m/menu-22.png') no-repeat 12px center/16px;
      }
      &:nth-child(3){
        background: url('@/assets/m/menu-33.png') no-repeat 12px center/16px;
      }
      &:nth-child(4){
        background: url('@/assets/m/menu-99.png') no-repeat 12px center/16px;
      }
      &:nth-child(5){
        background: url('@/assets/m/menu-66.png') no-repeat 12px center/16px;
      }
      &:nth-child(6){
        background: url('@/assets/m/menu-88.png') no-repeat 12px center/16px;
      }
      &:nth-child(7){
        background: url('@/assets/m/menu-77.png') no-repeat 12px center/16px;
      }
    }
  }
}
.message{
  width: 26px;
  height: 26px;
  background: url('@/assets/dggj/ico-26.png') no-repeat center center/13px #E8F1FF;
  border-radius: 50%;
  position: relative;
  margin-left: auto;
  &.hasUnread::before{
    content: '';
    display: block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #FF0000;
    position: absolute;
    top: 1px;
    right: 1px;
  }
}
</style>
